// OA 9 / 2024: In error situations we either pass this form data directly to our Slack
// from the server, or log it from the browser. Please do not add any confidential fields
// here that can't end up in Slack or in logs.
export type LeadFormRequest = {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  phone?: string;
  message?: string;
  gaClientId?: string;
  hubspotutk?: string;
  webinar_registrant_interest?: string;
  // HubSpot dropdown property "How did you first hear about Upright?" (internal option
  // name, e.g. "linkedin"). Only sent by facade forms that opt in, because the property
  // must exist on the target HubSpot form for the submission to be accepted.
  self_reported_source?: string;
  formId?: RequestDemoFormId | string;
  context?: PageContext;
  agreedToComms?: boolean;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
};

interface PageContext {
  pageUri: string;
  pageName: string;
}

export type RequestDemoResponse = {
  status: string;
};

export enum RequestDemoFormId {
  GENERIC_DEMO_REQUEST_LEGACY = '54abe55d-bce4-4d70-80aa-9e9d8cf8ba4f',
  GENERIC_CSRD = 'fdc3e12e-3dd1-4f4e-ad9f-d6264a5ff355',
  WEBINAR_DOWNLOAD_CSRD = 'c4325b9c-50c6-4864-b1b8-9bbd7383761f',
  WEBINAR_DOWNLOAD_SEPT24_RODENSTOCK = '6306502d-89e3-4051-a1ca-061eac0847e6',
  WEBINAR_REGISTER_CSRD_FOR_INVESTORS = '69dc1b27-f28c-46b7-808d-eb9fdd516ea5',
  WEBINAR_REGISTER_FUND_ODAI_LAUNCH = '5a850efa-f843-408d-b7e0-a7a785260949',
  WEBINAR_REGISTER_PE_FUND_LAUNCH = 'd753c1c9-f3a2-4e07-aa97-e89a83a4bc98',
  WEBINAR_REGISTER_CSRD_DMA_FINANCIAL_EFFECTS = 'b9d0d16a-6b7e-4945-97ea-d3c957178495',
  WEBINAR_REGISTER_CSRD_DMA_UPDATES = 'b32bcd8c-0f74-489a-bff7-8d830b44d2cd',
  WEBINAR_REGISTER_INVESTOR_AM = 'c381f9ba-5c29-47a1-9264-318864825abb',
  WEBINAR_REGISTER_EU_OMNIBUS = 'b0c2e730-9a85-4ac0-becf-9da42e8a2f0c',
  DOCUMENTATION_DOWNLOAD_CSRD = 'd4081ba2-bbaf-430c-8fb3-c911552dbfac',
  GENERIC_INVESTOR = '9a28d6be-01e9-4592-b805-0dc8f7d5d0d9',
  GENERIC_CORPORATE = '3bb7a516-1738-4fb0-8394-98d90c11219f',
  GENERIC_GA = '8a9175f1-7ffd-4b5b-8500-db2b6ec0ab90',
  DOWNLOAD_FUND_IMPACT_REPORT = '313fed1a-7cfa-4a5d-b398-8da3ccece246',
  WEBINAR_REGISTER_CSRD_DMA_50K_PROFILES = '4d2a31ff-f4df-41d2-ae71-7b9332be486c',
  WEBINAR_REGISTER_ESG_IMPACT_DATA_FOR_PRIVATE_MARKETS = 'e15e1cdb-1718-4c12-b69a-b6c41e901b64',
  WEBINAR_REGISTER_DMA_AS_STRATEGIC_TOOL = 'c3bf9c9f-207e-4aba-8dee-261470f39171',
  WEBINAR_REGISTER_RETHINKING_SDG = '280ba380-6c53-447f-8050-ecde8a7c9036',
  WEBINAR_REGISTER_FAILING_DMA = 'dc0300e0-6e55-4d7f-8993-25651eb181d1',
  WEBINAR_REGISTER_PLG_DMA_LAUNCH = '951f8715-9a88-47ae-9afa-c5066bd2ac99',
  WEBINAR_REGISTER_STOREBRAND_ASSET_MANAGEMENT = 'ac1b1e7b-f8a4-478c-a698-2116590bb308',

  GENERIC_INVESTOR_BOOK_DEMO_AUG2025 = '05ded781-1272-4e9d-9a67-50aba2fb4e3c',
  GENERIC_CSRD_BOOK_DEMO_AUG2025 = '9a394508-84b6-47ae-9e9f-866b416fc7ae',
}
